export default function componentStyleOverrides(theme) {
  return {
    MuiClockNumber: {
      styleOverrides: {
        root: {
          color: theme.darkTextPrimary,
          fontSize: '1rem',
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          '.Mui-disabled': {
            color: 'rgba(0, 0, 0, 0.2)',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          boxShadow: 'none',
          padding: '.3em 1.4em',
          letterSpacing: '1.71px',
          fontSize: '1.2rem',
          borderRadius: '8px',
          color: 'white',
          background: theme.darkBlack,
          '&:hover, &:focus': {
            background: theme.dark,
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: theme.black,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '&.Mui-checked, &.Mui-selected svg': {
            color: theme.black,
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: theme.middleGray,
          marginBottom: '4px',
          fontSize: '1rem',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '& .MuiCheckbox-root, & .MuiRadio-root': {
            padding: '4px 9px',
          },
        },
        label: {
          fontSize: '1rem',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          '&.Mui-selected, &.Mui-selected svg': {
            color: theme.darkBlack,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          color: theme.lightBackgroundText,
          backgroundColor: 'transparent',
          boxShadow: 'none',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: { '&:last-child': { paddingBottom: 0 } },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: { fontSize: '12px', marginLeft: 0 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: { padding: '2px 0' },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          whiteSpace: 'pre-wrap',
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          color: theme.lightBlack,
          '&.Mui-active': {
            color: theme.darkBlack,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&.MuiInputBase-inputAdornedEnd': {
            paddingRight: '12px',
            paddingLeft: '0px',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
  };
}
